import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-sand py-12 sm:py-14" data-id="element-192" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl px-5" data-id="element-193" data-mp="4vjn44ww56f5">
        <div className="flex flex-col items-center gap-4 rounded-2xl border border-gold/40 bg-ivory p-6 text-center sm:flex-row sm:gap-5 sm:p-7 sm:text-left" data-id="element-194" data-mp="9ttiogmj291a">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold-soft ring-1 ring-gold/40" data-id="element-195" data-mp="ercwxgj86lt8">
            <ShieldCheckIcon className="h-6 w-6 text-gold-deep" aria-hidden data-id="element-196" data-mp="ntvylxb9ysdw" />
          </span>
          <div data-id="element-197" data-mp="sl478r4s69q0">
            <h2 className="font-display text-lg font-bold uppercase text-charcoal sm:text-xl" data-id="element-198" data-mp="skcedo2kiq3f">
              Garantía <span className="tabular-nums" data-id="element-199" data-mp="xk73pn6p37md">7</span> días — sin preguntas
            </h2>
            <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-charcoal/70" data-id="element-200" data-mp="12jjxkrvzheyg">
              Entrá al Método Consultorio Rentable, recorré los 5 tomos y empezá a aplicarlo. Si
              dentro de los primeros 7 días sentís que no es para tu consultorio, pedís la devolución
              y recuperás el{' '}
              <strong className="font-semibold text-charcoal" data-id="element-201" data-mp="20s2jqo5lgcg1">100% de tu compra</strong>. Sin
              vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}